<template>
    <SideFormSection>
        <template #title> General Settings </template>
        <template #subtitle>
            Service settings, title, description, duration, minimum booking
            hours in advance, and more.
        </template>
        <template #rawContent>
            <Card
                title="General Settings"
                iconName="gears"
            >
                <template #content>
                    <ApiForm
                        :url="
                            urlFactory.makeServiceUpdateGeneralSettingsUrl(
                                localServiceAggregate.service.id,
                            )
                        "
                        method="POST"
                        ref="apiFormRef"
                    >
                        <ServiceForm
                            :meetingLocations="meetingLocations"
                            :serviceAggregate="localServiceAggregate"
                            :errors="
                                apiFormRef?.response?.getErrors() ??
                                new ApiFormErrors({})
                            "
                        />
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import ServiceForm from '@/App/Service/Component/Service/ServiceForm.vue'
    import Integration from '@/App/Integration/Entity/Integration'
    import Button from '@/Shared/Component/Button.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import type ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import {
        ResponseJsonKeyEnum,
        type MeetingLocationType,
    } from '@/Shared/AutoGenerated/Main'

    const props = defineProps({
        serviceAggregate: {
            type: Object as PropType<ServiceAggregate>,
            required: true,
        },
        paymentIntegrations: {
            type: Array as PropType<Integration[]>,
            required: true,
        },
        meetingLocations: {
            type: Array as PropType<MeetingLocationType[]>,
            required: true,
        },
    })

    const localServiceAggregate = ref<ServiceAggregate>(props.serviceAggregate)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()?.then((response: ApiFormResponseType) => {
            localServiceAggregate.value = response.getHydratedServiceAggregate(
                ResponseJsonKeyEnum.App_Service_Update_ServiceAggregateData,
            )
        })
    }
    const urlFactory = new UrlFactory()
</script>
